import { defineMessages } from 'react-intl'

export default defineMessages({
    orderNumber: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportResults.orderNumber',
        defaultMessage: 'No.',
    },
    date: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportResults.date',
        defaultMessage: 'Date',
    },
    customerNumber: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportResults.customerNumber',
        defaultMessage: 'Customer no.',
    },
    customerName: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportResults.customerName',
        defaultMessage: 'Customer name',
    },
    heading: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportResults.heading',
        defaultMessage: 'Heading',
    },
    currency: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportResults.currency',
        defaultMessage: 'Currency',
    },
    sendOrders: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportResults.sendOrders',
        defaultMessage: 'Send Orders',
    },
    noData: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportResults.noData',
        defaultMessage: 'No draft orders found',
    }
})
